import { DG } from '@cotera/sdk/core';

const GOOGLE_SEARCH_TEMPLATE: DG.DocumentEditor.DocumentState = {
  type: 'doc',
  content: [
    {
      type: 'heading',
      attrs: {
        id: 'd0d5ee79-fcb7-442c-a00f-c4cf8f095a34',
        textAlign: null,
        level: 1,
      },
      content: [
        {
          type: 'text',
          text: 'Template: Google Search',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '0be5ee65-7b64-4a80-8e17-5dddea0a53c5',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'Replace the ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
          ],
          text: 'Example',
        },
        {
          type: 'text',
          text: ' and [text]',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: ' ',
        },
        {
          type: 'text',
          text: 'sections with your own information!',
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: 'd37ffd84-e1ef-4b28-a829-15a594c09c51',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Task',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '44129be0-9b24-4d9e-a068-b9c7a2dacc77',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'Use the ',
        },
        {
          type: 'mention',
          attrs: {
            id: 'google_search',
            label: 'google_search',
            color: 'purple',
            data: '{"t":"tool","name":"google_search"}',
          },
        },
        {
          type: 'text',
          text: ' tool to',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: ' [WHAT YOU WANT TO FIND]',
        },
        {
          type: 'text',
          text: '.',
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: 'f06a4b67-b765-4868-b4b1-d63d1c42ee9f',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example: Use the ',
            },
            {
              type: 'text',
              marks: [
                {
                  type: 'code',
                },
              ],
              text: 'googlesearch_web_search',
            },
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: ' tool to identify which "National Day" observances occur on a given date.',
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: 'a313951c-66b3-4765-bf0a-fe719b395c25',
        textAlign: null,
        level: 3,
      },
      content: [
        {
          type: 'text',
          text: 'Input',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '503f2e9f-6ec4-479f-a6a0-d833bd5e77b9',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'The user will provide: ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-bg-color)',
              },
            },
          ],
          text: '[DESCRIPTION OF WHAT THE USER WILL INPUT]',
        },
        {
          type: 'hardBreak',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: 'Example: The user will provide a date (e.g., "March 15" or "March 15, 2025")',
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: 'f99d8323-602b-482a-9a41-160e334e5cb3',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Context',
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '71639401-e1c2-4ebf-98ef-a677e431cd88',
        textAlign: null,
        level: 3,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'What to Search For',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '2d5d2e40-93c9-41b8-adea-38a4fa31d24d',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: "[DESCRIPTION OF INFORMATION YOU'RE LOOKING FOR] ",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: 'd23d6d25-b337-4fd8-93d8-3aa01227540b',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example: Official "National Day" celebrations, food holidays, awareness days, and unofficial observances for a given date',
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: 'fa1154b4-67b6-462f-a939-0ef3bea26bb2',
        textAlign: null,
        level: 3,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Search Strategy',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '105a8636-a2dc-4989-9ed4-efddb84ba99e',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[HOW YOU WANT TO SEARCH OR QUERY APPROACH] ',
                },
                {
                  type: 'hardBreak',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'italic',
                    },
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-color-highlight-brown)',
                      },
                    },
                  ],
                  text: 'Example: Search for "national days [date]" or "[month] [day] national day calendar"',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '6e04c3e3-5990-4d84-bf4d-e6080e2223f6',
        textAlign: null,
        level: 3,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'What Counts as a Valid Result',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: 'ad197f4f-15d0-4647-ae20-08bc8a59db45',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[CRITERIA FOR INCLUDING/EXCLUDING RESULTS]',
                },
                {
                  type: 'text',
                  text: ' ',
                },
                {
                  type: 'hardBreak',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'italic',
                    },
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-color-highlight-brown)',
                      },
                    },
                  ],
                  text: 'Example: Include both official government-recognized days and popular cultural observances. ',
                },
                {
                  type: 'hardBreak',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'italic',
                    },
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-color-highlight-brown)',
                      },
                    },
                  ],
                  text: 'Exclude purely commercial promotions unless widely recognized',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: 'b1eec7e3-80ef-4e20-8641-abfae2d448bf',
        textAlign: null,
        level: 3,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Output',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'e8f55edd-b87a-4730-ae20-6a4500d6246c',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'This example output returns an object with the date of interest, the holiday, and a description of the holiday, from our "National Day" example. Edit this to fit your output needs!',
        },
      ],
    },
    {
      type: 'response-shape',
      attrs: {
        jsonNode: {
          t: 'object',
          name: 'response',
          fields: {
            '0.3267930667278931': {
              t: 'timestamp',
              name: 'date',
              nullable: false,
            },
            '0.8750354792487032': {
              t: 'string',
              name: 'description_summary',
              nullable: false,
            },
            '6b13c865-47bd-4543-8419-6e9cede8ac90': {
              t: 'string',
              name: 'calendar_day',
              nullable: false,
            },
          },
          nullable: false,
        },
      },
    },
    {
      type: 'paragraph',
      attrs: {
        id: '45dde737-9c91-4987-9cb6-ab95131ce1e4',
        textAlign: null,
      },
    },
  ],
};

const FIND_MENTIONS_OF_TEMPLATE: DG.DocumentEditor.DocumentState = {
  type: 'doc',
  content: [
    {
      type: 'heading',
      attrs: {
        id: '473eeb1f-16c6-4076-9f50-9a465d773eb2',
        textAlign: null,
        level: 1,
      },
      content: [
        {
          type: 'text',
          text: 'Template: Find Mentions Of...',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'f1044e61-3eec-4ac7-bbfa-05268edba848',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'Replace the ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
          ],
          text: 'Example',
        },
        {
          type: 'text',
          text: ' and [text]',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: ' ',
        },
        {
          type: 'text',
          text: 'sections with your own information!',
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '8c704826-899d-455a-8411-7afbcaf81516',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Task',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '5b575050-0828-4e7c-a820-7a7c6cc6f916',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'Your task is to analyze ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[TYPE OF DATA/CONTENT]',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: ' ',
        },
        {
          type: 'text',
          text: 'and determine if it mentions topics related to ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[TOPIC/THEME/CRITERIA OF INTEREST]',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
          ],
          text: '.',
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: '2c6bc09c-1fa9-4995-82f4-1af98e3a4383',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
                {
                  type: 'highlight',
                  attrs: {
                    color: 'var(--tt-bg-color)',
                  },
                },
              ],
              text: 'Example: Your task is to analyze customer feedback surveys and determine if it mentions topics related to pricing concerns',
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: 'e5ce3690-36a8-4c8b-a10d-bb18d16437f8',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Context:',
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '8f765d48-9b84-46f4-b7e0-01be2769c25a',
        textAlign: null,
        level: 3,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: '[Topic/Theme] Overview',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '747123ad-68f9-46b9-aad3-c5617ecc2330',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: "[WHAT YOU'RE LOOKING FOR AND WHY]",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: '17f2d544-ea08-410c-b27c-b52db904c538',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
                {
                  type: 'highlight',
                  attrs: {
                    color: 'var(--tt-bg-color)',
                  },
                },
              ],
              text: 'Example: Pricing concerns include any mentions of cost being too high, requests for discounts, or confusion about billing',
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '601d4ab0-cb83-461e-a656-c9e9456f5fff',
        textAlign: null,
        level: 3,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'What Constitutes a Mention:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '99f41416-3920-4db3-8e5a-4e6b8a787b51',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[EXPLICIT INDICATORS] ',
                },
                {
                  type: 'hardBreak',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-color-highlight-brown)',
                      },
                    },
                  ],
                  text: ' ',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'italic',
                    },
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-color-highlight-brown)',
                      },
                    },
                  ],
                  text: "Example: too expensive, can't afford, price increase",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '0d5979e9-4ab9-42e9-a723-02d33787fb30',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[IMPLICIT INDICATORS] ',
                },
                {
                  type: 'hardBreak',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-bg-color)',
                      },
                    },
                  ],
                  text: ' ',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'italic',
                    },
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-color-highlight-brown)',
                      },
                    },
                  ],
                  text: "Example: References to budgets, comparing to competitors' prices, or canceling due to cost",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '202aa34e-5ddd-4387-b6ee-f0da72a6ee62',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[GUIDANCE ON VARIATIONS] ',
                },
                {
                  type: 'hardBreak',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-color-highlight-brown)',
                      },
                    },
                  ],
                  text: ' ',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'italic',
                    },
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-color-highlight-brown)',
                      },
                    },
                  ],
                  text: 'Example: pricey, costs too much, $$$, common typos like "expensiv"',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '8969a9f0-d27f-42e5-8f4b-17c334347f0d',
        textAlign: null,
        level: 3,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Boundary Cases:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: 'a7e28979-15aa-42aa-b61f-a9f0633691c4',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[GUIDANCE ON WHAT TO INCLUDE] ',
                },
                {
                  type: 'hardBreak',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-color-highlight-brown)',
                      },
                    },
                  ],
                  text: ' ',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'italic',
                    },
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-color-highlight-brown)',
                      },
                    },
                  ],
                  text: 'Example: Include mentions of "value for money" even if not explicitly negative',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '592c0fd5-fea5-4f3f-9e70-6d3726147218',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-bg-color)',
                      },
                    },
                  ],
                  text: '[GUIDANCE ON WHAT TO EXCLUDE] ',
                },
                {
                  type: 'hardBreak',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-color-highlight-brown)',
                      },
                    },
                  ],
                  text: ' ',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'italic',
                    },
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-color-highlight-brown)',
                      },
                    },
                  ],
                  text: 'Example: Exclude general compliments about features unless they mention price',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '6770c1f4-6e18-47bb-8d24-5a39406f0678',
        textAlign: null,
        level: 3,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Output:',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '4297ed4e-675a-4dc5-a45c-21959ee1e984',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'For each piece of data, indicate whether it matches your criteria and provide a brief explanation citing the specific language or pattern that led to your decision.',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'c02f5128-a328-4455-83b7-46c02f260658',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'The output type has a boolean (true/false) for topic identification, then an explanation string that tells you ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
          ],
          text: 'why',
        },
        {
          type: 'text',
          text: ' the agent made the decision. This is extremely helpful for iterating on the prompt to get the exact results you want!',
        },
      ],
    },
    {
      type: 'response-shape',
      attrs: {
        jsonNode: {
          t: 'object',
          name: 'response',
          fields: {
            '0.8293733838791025': {
              t: 'string',
              name: 'explanation',
              nullable: false,
            },
            '9b9b3afb-dc29-40a4-96b3-ee20953358d0': {
              t: 'boolean',
              name: 'is_topic',
              nullable: false,
            },
          },
          nullable: false,
        },
      },
    },
    {
      type: 'paragraph',
      attrs: {
        id: '3fcd173d-1a66-4edf-a625-77f08aaf50f9',
        textAlign: null,
      },
    },
  ],
};

const MEETING_SUMMARY_TEMPLATE: DG.DocumentEditor.DocumentState = {
  type: 'doc',
  content: [
    {
      type: 'heading',
      attrs: {
        id: '0f2d7fb5-9bed-4860-a2c8-26bbb253aa3a',
        textAlign: null,
        level: 1,
      },
      content: [
        {
          type: 'text',
          text: 'Template: Meeting/Transcript Summary',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '681c0624-987d-49e5-8181-fef4b6745afb',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'Replace the Example and [text] sections with your own information!',
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: 'eb048d27-9fe8-4bcf-98b6-46a0108de1a7',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Task',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'bd08f502-58d9-468b-8c90-6d8294674f19',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'Analyze the provided transcript and create a structured summary that captures',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
          ],
          text: ' ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[WHAT YOU WANT TO EXTRACT]',
        },
        {
          type: 'text',
          text: '.',
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: '75589128-a041-4cc1-bc4c-3734baa0ba77',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example: Analyze the provided transcript and create a structured summary that captures key decisions, action items, main discussion topics, and any unresolved questions',
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '9d69deec-f4ee-4767-8316-c5d8097685e1',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Input',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'd220a9d4-1743-4fe2-8bff-d3963ff2ac2a',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'The user will provide:',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
          ],
          text: ' ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[DESCRIPTION OF TRANSCRIPT TYPE/SOURCE]',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '40e502f5-331a-41df-8fa5-952e7cd74df4',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: 'Example: The user will provide a transcript from a customer success call, team meeting, or interview recording',
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '5f0a1e4c-84ba-4462-98d2-ac493a29c38c',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Context',
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: 'f6b1e244-c9ee-4ddd-ad8f-89ca63bfbf7e',
        textAlign: null,
        level: 3,
      },
      content: [
        {
          type: 'text',
          text: 'Transcript Details',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '6716f1ff-a97a-4031-a315-3d9f1d85aaba',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[INFORMATION ABOUT THE TRANSCRIPT CONTEXT]',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '27876a27-e9e3-45d4-a70c-4803e5243bd6',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: 'Example: This is a weekly product planning meeting with engineering, design, and product management stakeholders. The team discusses feature prioritization, technical blockers, and sprint planning',
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '00cb7b46-0807-47ea-9859-56fc8b1d3891',
        textAlign: null,
        level: 3,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-bg-color)',
              },
            },
          ],
          text: 'What to Focus On',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'a1840b56-0ba5-4047-9521-2d60bea7e6f3',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[SPECIFIC ELEMENTS YOU WANT HIGHLIGHTED]',
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: 'd9a0a91e-7ecc-4600-994e-ea35d8573644',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example: Pay special attention to:',
            },
          ],
        },
        {
          type: 'bulletList',
          content: [
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'a32d982d-ced6-4a22-9421-f6f42d459c9a',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Concrete decisions that were made (not just discussed)',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '40f1904e-a056-4843-8fde-a828281331bb',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Action items with clear owners',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '4d144e19-98f1-4f2e-aa59-1a8c20f43964',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Timeline commitments or deadlines',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '3a879368-f562-4c80-9a32-3dce43378c0b',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Technical blockers or dependencies',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '007c3472-fdaa-495e-83d5-5399ca70e767',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Customer feedback or pain points mentioned',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '8786015f-fb69-4f25-8e39-bc84aef3117d',
        textAlign: null,
        level: 3,
      },
      content: [
        {
          type: 'text',
          text: 'What to Ignore or Deprioritize',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'a239e099-65f4-4c09-8e07-97b6705da923',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[ELEMENTS TO SKIP OR MINIMIZE]',
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: 'dadbe5b1-09b2-4f50-bd9d-51c6255f4945',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example: Minimize or exclude:',
            },
          ],
        },
        {
          type: 'bulletList',
          content: [
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '5c076be6-2c52-4795-b065-c33bba08b692',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Off-topic tangents or casual conversation',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'f9a11d2f-a1d0-47fb-9d11-2b79a40806b6',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Repeated information (consolidate duplicates)',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '30ddeb4d-3174-49be-9858-44fa18585646',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: "Detailed technical implementation unless it's a key decision point",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: 'b7304caf-d887-4aba-8a32-b50491b3335b',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Output Structure',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'd6587ab3-3bb2-41d6-8b0b-b0ffd4048bde',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'Your summary should include the following sections:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: 'db007e04-f03b-4dae-b8dc-fa46796937aa',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[SECTION 1 NAME]',
                },
              ],
            },
            {
              type: 'bulletList',
              content: [
                {
                  type: 'listItem',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: {
                        id: 'd92c17fe-e0b7-443b-a39f-a0d93a9a2e76',
                        textAlign: null,
                      },
                      content: [
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                color: 'var(--tt-color-text-blue)',
                              },
                            },
                            {
                              type: 'bold',
                            },
                          ],
                          text: '[DESCRIPTION OF WHAT GOES HERE]',
                        },
                        {
                          type: 'hardBreak',
                        },
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'italic',
                            },
                            {
                              type: 'highlight',
                              attrs: {
                                color: 'var(--tt-color-highlight-brown)',
                              },
                            },
                          ],
                          text: "Example: Executive Summary - A 2-3 sentence overview of the meeting's purpose and main outcomes",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: 'd0fd63f9-89e6-41e1-875e-fc992992c481',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-bg-color)',
                      },
                    },
                  ],
                  text: '[SECTION 2 NAME]',
                },
              ],
            },
            {
              type: 'bulletList',
              content: [
                {
                  type: 'listItem',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: {
                        id: '683848cd-4134-4cb3-b1ef-77158cb49023',
                        textAlign: null,
                      },
                      content: [
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                color: 'var(--tt-color-text-blue)',
                              },
                            },
                            {
                              type: 'bold',
                            },
                            {
                              type: 'highlight',
                              attrs: {
                                color: 'var(--tt-bg-color)',
                              },
                            },
                          ],
                          text: '[DESCRIPTION OF WHAT GOES HERE]',
                        },
                        {
                          type: 'hardBreak',
                        },
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'italic',
                            },
                            {
                              type: 'highlight',
                              attrs: {
                                color: 'var(--tt-color-highlight-brown)',
                              },
                            },
                          ],
                          text: 'Example: ',
                        },
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'italic',
                            },
                            {
                              type: 'highlight',
                              attrs: {
                                color: 'var(--tt-color-highlight-brown)',
                              },
                            },
                          ],
                          text: 'Key Decisions',
                        },
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'italic',
                            },
                            {
                              type: 'highlight',
                              attrs: {
                                color: 'var(--tt-color-highlight-brown)',
                              },
                            },
                          ],
                          text: ' - List each decision made with brief context. Format: "Decision: [what was decided] - Rationale: [why]"',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '6b64a206-9458-4b17-be34-9202f71bf608',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-bg-color)',
                      },
                    },
                  ],
                  text: '[SECTION 3 NAME]',
                },
              ],
            },
            {
              type: 'bulletList',
              content: [
                {
                  type: 'listItem',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: {
                        id: 'f500ca70-4b66-4e34-8bf7-684733b2a06f',
                        textAlign: null,
                      },
                      content: [
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                color: 'var(--tt-color-text-blue)',
                              },
                            },
                            {
                              type: 'bold',
                            },
                            {
                              type: 'highlight',
                              attrs: {
                                color: 'var(--tt-bg-color)',
                              },
                            },
                          ],
                          text: '[DESCRIPTION OF WHAT GOES HERE]',
                        },
                        {
                          type: 'hardBreak',
                        },
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'italic',
                            },
                            {
                              type: 'highlight',
                              attrs: {
                                color: 'var(--tt-color-highlight-brown)',
                              },
                            },
                          ],
                          text: 'Example: ',
                        },
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'italic',
                            },
                            {
                              type: 'highlight',
                              attrs: {
                                color: 'var(--tt-color-highlight-brown)',
                              },
                            },
                          ],
                          text: 'Action Items',
                        },
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'italic',
                            },
                            {
                              type: 'highlight',
                              attrs: {
                                color: 'var(--tt-color-highlight-brown)',
                              },
                            },
                          ],
                          text: " - Each action item should include: what needs to be done, who is responsible, and when it's due (if mentioned)",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: 'a7bf3c9c-8d13-4f9e-81fd-bec33c5c1d67',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-bg-color)',
                      },
                    },
                  ],
                  text: '[SECTION 4 NAME]',
                },
              ],
            },
            {
              type: 'bulletList',
              content: [
                {
                  type: 'listItem',
                  content: [
                    {
                      type: 'paragraph',
                      attrs: {
                        id: '8226754e-98a0-4d17-8ddd-20a9c073d433',
                        textAlign: null,
                      },
                      content: [
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                color: 'var(--tt-color-text-blue)',
                              },
                            },
                            {
                              type: 'bold',
                            },
                            {
                              type: 'highlight',
                              attrs: {
                                color: 'var(--tt-bg-color)',
                              },
                            },
                          ],
                          text: '[DESCRIPTION OF WHAT GOES HERE]',
                        },
                        {
                          type: 'hardBreak',
                        },
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'italic',
                            },
                            {
                              type: 'highlight',
                              attrs: {
                                color: 'var(--tt-color-highlight-brown)',
                              },
                            },
                          ],
                          text: 'Example: ',
                        },
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'bold',
                            },
                            {
                              type: 'italic',
                            },
                            {
                              type: 'highlight',
                              attrs: {
                                color: 'var(--tt-color-highlight-brown)',
                              },
                            },
                          ],
                          text: 'Main Discussion Topics',
                        },
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'italic',
                            },
                            {
                              type: 'highlight',
                              attrs: {
                                color: 'var(--tt-color-highlight-brown)',
                              },
                            },
                          ],
                          text: ' - Brief summaries of the major topics covered, with key points under each',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '946613e2-a18f-48cd-b2cc-aaa9cd5584d1',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Tone and Style',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '56286c2a-18bf-4baa-ac73-532077ee05f5',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[HOW YOU WANT THE SUMMARY WRITTEN]',
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: '0533140e-1cfa-47e5-884a-d1e5063d3916',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
                {
                  type: 'highlight',
                  attrs: {
                    color: 'var(--tt-bg-color)',
                  },
                },
              ],
              text: 'Example: Use clear, concise language. Write in bullet points for scannability. Be objective and factual. Use present tense for decisions and future tense for action items',
            },
            {
              type: 'hardBreak',
            },
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
                {
                  type: 'underline',
                },
                {
                  type: 'highlight',
                  attrs: {
                    color: 'var(--tt-bg-color)',
                  },
                },
              ],
              text: 'If you have an example, this would be a great place to add one!',
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'cdb4518e-af52-4714-b751-8085045f1a17',
        textAlign: null,
      },
    },
    {
      type: 'paragraph',
      attrs: {
        id: '6add8e53-8f7e-46b7-ba83-71546cbeaff2',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'This output shape separates each section into its own component. You may want a cohesive summary that contains all ',
        },
      ],
    },
    {
      type: 'response-shape',
      attrs: {
        jsonNode: {
          t: 'object',
          name: 'response',
          fields: {
            '0.2407177790271975': {
              t: 'string',
              name: 'action_items',
              nullable: false,
            },
            '0.6052964355066321': {
              t: 'string',
              name: 'key_decisions',
              nullable: false,
            },
            '0.12468932740323524': {
              t: 'string',
              name: 'main_discussion_topics',
              nullable: false,
            },
            '3369cfd6-2606-4d06-a823-f54975f3239b': {
              t: 'string',
              name: 'executive_summary',
              nullable: false,
            },
          },
          nullable: false,
        },
      },
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'd63efda3-6493-4937-b1fc-199d772d081a',
        textAlign: null,
      },
    },
  ],
};

export const CONTENT_CLASSIFIER_TEMPLATE: DG.DocumentEditor.DocumentState = {
  type: 'doc',
  content: [
    {
      type: 'heading',
      attrs: {
        id: 'bf677a89-22df-4491-bb31-63c285b5e9ba',
        textAlign: null,
        level: 1,
      },
      content: [
        {
          type: 'text',
          text: 'Template: Content Classifier',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'cce10228-9185-4bed-a8c1-e7c51d095e52',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'Replace the Example and [text] sections with your own information!',
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '66ee440f-7151-497c-b1d8-35186e577312',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Task',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'da344c11-b7dd-425e-b351-c57e5faa8cd5',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'Your task is to analyze ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[TEXT TYPE]',
        },
        {
          type: 'text',
          text: ' from ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[SOURCE/CONTEXT]',
        },
        {
          type: 'text',
          text: ' and categorize each item into one of the predefined categories based on its content and intent.',
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: 'd6506b32-a1c6-4543-9b42-30bcd41ebb71',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example: Your task is to analyze customer support tickets from ShipFast, a SaaS shipping platform that helps e-commerce businesses manage multi-carrier shipping, and categorize each item into one of the predefined categories based on its content and intent.',
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '7fd389d7-a861-4aa5-b329-431b9a703bbb',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Background',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '0be391f7-10d5-4f1e-b9bf-3bc2d2f4e20c',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[PROVIDE RELEVANT CONTEXT ABOUT YOUR TEXT SOURCE]',
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: '868a2238-304f-4708-ba91-fd0955b617a9',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example: Provide relevant background about the text source that helps with categorization:',
            },
          ],
        },
        {
          type: 'bulletList',
          content: [
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '8583fdbf-be78-43b1-9564-2830536b2b8e',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'ShipFast integrates with multiple carriers (USPS, FedEx, UPS) and e-commerce platforms (Shopify, WooCommerce)',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'd463ad01-8955-44a0-a6c0-622958f915cf',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Customers use our API to generate shipping labels, track packages, and manage returns',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'aedec48f-340b-44f0-ac72-e8717179274a',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'We offer both a web dashboard and REST API for integration',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'c097604e-b4c5-4aeb-8209-3ebbe1359b6b',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Common user personas include: e-commerce merchants, developers integrating our API, and warehouse operations teams',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '53be00fe-196a-4040-b566-25e782d16862',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Context: Category Definitions',
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '2672f4c1-895e-4a7f-80d6-833e37d4118d',
        textAlign: null,
        level: 3,
      },
      content: [
        {
          type: 'text',
          text: '1. ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[CATEGORY 1 NAME]',
        },
        {
          type: 'text',
          text: ' Definition:',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '427cf2b6-c5fc-4e6f-a1b7-a9ecfbf322f8',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[CLEAR DEFINITION OF WHAT CONSTITUTES THIS CATEGORY]',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'bcb010f4-6d5e-4e0d-8a90-e5b4cc76094d',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: 'Example: ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
            {
              type: 'italic',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: 'Technical Integration Issues',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: ' - Problems related to API implementation, authentication, webhook configuration, or code-level integration challenges',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '510cda86-4792-4c37-92a5-845e297dbffd',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Specific characteristics or keywords to look for:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: 'e7605e8f-f331-4971-b061-f00ba07fb048',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[LIST KEY INDICATORS]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: '1b24b161-d789-4e63-9137-a495ceba3c6b',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example:',
            },
          ],
        },
        {
          type: 'bulletList',
          content: [
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '6ccb03db-deb5-4e96-82c4-166606520be9',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Mentions of API endpoints, authentication tokens, or error codes',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '2f8a6663-2b7b-406c-ab82-7c2d1022e976',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'References to SDK usage, webhook failures, or rate limiting',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'bb17b99e-9f3e-49a1-b3e9-89175050f89f',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Technical terminology like "POST request," "JSON response," "OAuth"',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '49a7d518-b850-40aa-a99a-3aa7d1bd396c',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Examples of content that would fit this category:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '37e79e82-e431-4ed7-a7ca-2e64ee045260',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[PROVIDE 2-3 CONCRETE EXAMPLES]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: 'f3efe5fb-0088-489f-ab58-91b18b3e28ac',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example:',
            },
          ],
        },
        {
          type: 'bulletList',
          content: [
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '8b0f3c16-2b92-4a08-8c50-d640c109c72e',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: '"Getting a 401 error when trying to authenticate with the API"',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '3817565c-428c-4d59-9e77-e71929d52236',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: '"Our webhook endpoint isn\'t receiving shipment.delivered events"',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '025f9ba5-24a2-45c7-b45f-5d1e2ac84783',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: '"How do I pass customs information in the label creation request?"',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'horizontalRule',
    },
    {
      type: 'heading',
      attrs: {
        id: 'b14b0c44-fd19-495e-8b32-e475871f0b5e',
        textAlign: null,
        level: 3,
      },
      content: [
        {
          type: 'text',
          text: '2. ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[CATEGORY 2 NAME]',
        },
        {
          type: 'text',
          text: ' Definition:',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '54994d4f-08e4-4506-93e8-3b2d190d29da',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[CLEAR DEFINITION OF WHAT CONSTITUTES THIS CATEGORY]',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'e5684787-42f8-4a38-8254-c92bae3c1cc8',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: 'Example: ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
            {
              type: 'italic',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: 'Billing & Account Management',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: ' - Questions or issues related to pricing, invoices, plan changes, payment methods, or account settings',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '8e0c06bb-c3a8-4eb2-946a-6cd297d10ff1',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Specific characteristics or keywords to look for:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '17a16be4-c5b5-4f26-bd33-039998e1d221',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[LIST KEY INDICATORS]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: '46875b30-e5cd-4297-b606-f19b6d272b9a',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example:',
            },
          ],
        },
        {
          type: 'bulletList',
          content: [
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'e1c018c6-ab05-4b37-90e0-e1b501ab2261',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'References to charges, invoices, credits, or refunds',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'c647a216-95e2-49a6-96ff-1559d984ffdd',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Mentions of plan upgrades/downgrades or pricing tiers',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'ffb8a945-63f6-46c1-aa31-839de513c4be',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Payment method updates or billing cycles',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'a7b4eb35-14a8-4300-b586-726b27ad872c',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Examples of content that would fit this category:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: 'f2a43d1d-dd2b-4e7c-a832-931c3b595702',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[PROVIDE 2-3 CONCRETE EXAMPLES]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: '6a76668f-d8e2-4104-8885-a444f62cc4d5',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example:',
            },
          ],
        },
        {
          type: 'bulletList',
          content: [
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '29e66c11-6efb-490d-a716-30e6da6a9aa6',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: '"Why was I charged twice this month?"',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'f74f020d-aeb2-4fd3-b9f2-183bd99d642c',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: '"How do I upgrade to the Enterprise plan?"',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '71ec75d6-3f91-4aed-953a-db32feb90803',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: '"Can I get an invoice for last quarter\'s usage?"',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'horizontalRule',
    },
    {
      type: 'heading',
      attrs: {
        id: '76bb0a20-d3ef-4ffc-9759-f69399102806',
        textAlign: null,
        level: 3,
      },
      content: [
        {
          type: 'text',
          text: '3. ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[CATEGORY 3 NAME]',
        },
        {
          type: 'text',
          text: ' Definition:',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '006b0308-8330-4745-9993-1f0fb61b7bb7',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[CLEAR DEFINITION OF WHAT CONSTITUTES THIS CATEGORY]',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '8ccef471-4a0c-44ce-9a9e-9ea46c8e7b07',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: 'Example: ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
            {
              type: 'italic',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: 'Shipping Operations',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: ' - Day-to-day operational issues with creating labels, tracking packages, handling returns, or carrier-specific problems',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '989abf65-c9d4-4357-aad3-00f04d1beb38',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Specific characteristics or keywords to look for:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '75fe8d9e-2ba2-41d6-9c44-066c7612c3d9',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[LIST KEY INDICATORS]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: '6e7489b8-7405-409b-8b30-826770b7def9',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example:',
            },
          ],
        },
        {
          type: 'bulletList',
          content: [
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '203b0db6-74dd-4c4b-8830-841d5bad5219',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'References to specific shipments, tracking numbers, or label issues',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '65fd471d-828e-48e0-b284-26bf512465b4',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Carrier-specific problems (USPS delays, FedEx pickup issues)',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '54261bfe-46b2-404a-8833-92f287ba30b5',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Package status questions or delivery problems',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '2afb1be6-3762-40e0-892a-d1d790e66a46',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Examples of content that would fit this category:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '71e630db-4a06-44cf-941f-2159c12853ee',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[PROVIDE 2-3 CONCRETE EXAMPLES]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: '1213fa73-7655-4406-a32d-c37e85545dab',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example:',
            },
          ],
        },
        {
          type: 'bulletList',
          content: [
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'b442c866-668d-4faa-9ff3-546a52dd34ba',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: '"My label printed with the wrong address"',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'be51928a-a600-4b4e-adbe-234a23c3519d',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: '"Tracking shows delivered but customer never received package"',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'e902bd77-955e-4c06-952c-7ccc0413207c',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: '"Can I schedule a FedEx pickup for tomorrow?"',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '08814657-4305-4b55-bd65-22a88890bd94',
        textAlign: null,
      },
    },
    {
      type: 'paragraph',
      attrs: {
        id: '4022fc66-319e-4b42-877e-9c82cdf0c367',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[ADD MORE CATEGORIES AS NEEDED - Copy the structure above]',
        },
      ],
    },
    {
      type: 'horizontalRule',
    },
    {
      type: 'heading',
      attrs: {
        id: '1e9628af-264c-45bd-899a-3b833ace9986',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Classification Guidelines',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'dcf41b6b-33fa-4ae5-a84a-b52ff03ed3f3',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Primary Focus:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: 'aa6890f6-e483-48f4-a78f-05c56ea456ea',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[HOW TO DETERMINE THE MAIN THEME]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '3c844578-8985-4293-b6d6-09acbf315536',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: 'Example: Categorize based on the main theme or intent of the text. If a ticket mentions billing while asking about API integration, focus on which issue is the primary request.',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'edfea99a-f2b1-42c6-9db8-6e972a34a5b0',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Keywords and Phrases:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '0b2fdd1b-ba66-4ed8-96a1-41d2c4798cb9',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[GUIDANCE ON KEYWORD MATCHING]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '0cafa796-27e8-499a-a636-8281fb55538d',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: 'Example: Look for explicit mentions of technical terms (API, endpoint, authentication) vs. business terms (invoice, plan, pricing) vs. operational terms (tracking, label, shipment)',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '79b7b790-75c8-4bf0-8291-02a78828e8a5',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Implicit References:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '090faf1c-9f5f-45fc-b8d9-297365b0865c',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[HOW TO HANDLE NON-OBVIOUS CATEGORIZATION]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'cce21de0-2c84-40f9-83d8-9b3d2751e2a3',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: 'Example: Include content that clearly relates to a category even without exact keyword matches. "The code isn\'t working" likely means Technical Integration, even without saying "API"',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '72e2e1fa-e8cc-4f1b-baf6-3f60ead67be9',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Context Matters:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '10a8541c-d5b1-4486-9c09-3aaf7c068310',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[ADDITIONAL CONTEXT CONSIDERATIONS]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '4385217d-320d-415d-8aa3-3cff83ba9d09',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: 'Example: Consider the overall meaning and user intent, not just individual words. "How much does expedited shipping cost?" is about Shipping Operations (service options), not Billing (pricing plans)',
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '38946668-2767-4b12-8e1e-e618ed07210a',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Boundary Cases',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'd716f169-9cd4-4c2e-ad3f-6cf9c5eb5cf1',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Mixed Content:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '30835cef-fed1-4e34-9945-fd6b57ec62e0',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[HOW TO HANDLE MULTI-TOPIC CONTENT]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: 'bb0d33a3-e0df-4fad-bbf7-880946bd30f7',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example: If text spans multiple categories, classify based on the primary/dominant theme. A ticket that says "I was charged for a label that failed to print" should be categorized as Billing & Account Management because the core issue is the charge, even though it mentions a label',
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'eb8dbbeb-65da-4ff5-850c-d60f15265ecb',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Ambiguous Cases:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '2e81b7ac-cc78-493c-afaf-8342ee5317f0',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[GUIDANCE FOR UNCLEAR SITUATIONS]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: 'b798b9fb-fbb9-4c09-bd39-3e0c200bceaf',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example: When unclear between two categories, consider the most likely user intent and what resolution they\'re seeking. "How do I set up international shipping?" could be Technical Integration (API setup) or Shipping Operations (using the feature) - look for technical language to distinguish',
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'd3df6934-1593-45ab-afbb-44c7750a2578',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'Edge Cases:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '22c560ed-6143-468d-be0a-1d233a7ebcdb',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[SPECIFIC EDGE CASES FOR YOUR DOMAIN]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: '8563045b-de42-4c0b-9135-33013ba01707',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example:',
            },
          ],
        },
        {
          type: 'bulletList',
          content: [
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '12c8a070-5b2b-4c8f-8253-206669bea54a',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Account access issues (password resets, login problems) → Billing & Account Management',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'c1b25bd0-9fa4-442e-aae8-7f2d348c0a6b',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Rate shopping questions (comparing carrier rates) → Shipping Operations',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '8b7e1acf-5085-41e5-9db1-e9b96f29e8a0',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Sandbox/test environment issues → Technical Integration',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '3e260892-3963-4d82-9b93-262d9e16204d',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Exclusions for N/A',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'dc00e8a2-1abb-4171-a09f-f625f4b93c1e',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: "Content that doesn't clearly fit any category:",
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '7773221d-2dbf-4b8d-97f9-0dd7aa621ea8',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[WHAT SHOULD BE MARKED AS N/A]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: 'aad407ba-5d36-4e57-b72a-82873e061091',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example:',
            },
          ],
        },
        {
          type: 'bulletList',
          content: [
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '4b0bb036-16ba-4ea4-a43e-23723b12e7a4',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'General inquiries about the service ("What are your office hours?")',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'c7e06c9d-9623-4ada-880b-dd98aa62d975',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Feedback or feature requests that don\'t involve an issue ("Would love a dark mode!")',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '884d6464-a2bb-476f-b49d-a86df9f4b3a5',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Spam or unrelated content',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '5e4e2ac0-77d0-4c22-abd3-c0eedc4cbde4',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[SPECIFIC TYPES OF CONTENT TO EXCLUDE]',
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: 'b8aea32b-c6f3-4ebb-a3d5-ef623fe39b25',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example:',
            },
          ],
        },
        {
          type: 'bulletList',
          content: [
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '6af80072-908a-4685-93f3-d768270a1508',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Purely conversational messages ("Thanks for the help!")',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'fe39fb39-420c-42ca-94e8-b7ce061e3b45',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Duplicate or follow-up messages with no new information',
                    },
                  ],
                },
              ],
            },
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '47d1a424-5139-46b1-b722-96edb05d3acd',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Auto-generated system notifications',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '93b7bdc4-cd82-4519-b889-38bcd47fd60c',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Quality Checks',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '8f236aab-9dbc-4471-af68-c3d3cd8b40ca',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'Before finalizing your classification, verify:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '3028fb55-ffbc-4ac7-8bba-6b24d4ec035c',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[VERIFICATION STEP 1]',
                },
                {
                  type: 'hardBreak',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'italic',
                    },
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-color-highlight-brown)',
                      },
                    },
                  ],
                  text: 'Example: Does the text have a clear primary focus that matches one category?',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: 'e2b332dd-865f-4cd7-a90b-818f0e85a199',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[VERIFICATION STEP 2]',
                },
                {
                  type: 'hardBreak',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'italic',
                    },
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-color-highlight-brown)',
                      },
                    },
                  ],
                  text: 'Example: Are there explicit or implicit indicators pointing to a specific category?',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '8238f451-85db-4b3d-8c4b-1ec94dcce8a3',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'bold',
                    },
                  ],
                  text: '[VERIFICATION STEP 3]',
                },
                {
                  type: 'hardBreak',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'italic',
                    },
                    {
                      type: 'highlight',
                      attrs: {
                        color: 'var(--tt-color-highlight-brown)',
                      },
                    },
                  ],
                  text: 'Example: If unsure, lean toward the category with the strongest evidence. When truly ambiguous, explain your reasoning',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'horizontalRule',
    },
    {
      type: 'heading',
      attrs: {
        id: '65e79bea-a2e9-44d8-b520-14601e802eb0',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Input Format',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '7b3cafb7-4d2d-4d37-8dfb-bc974339af86',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[DESCRIBE HOW THE TEXT WILL BE PROVIDED]',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'a2bbcc90-06d9-42d4-870a-090c5173c6de',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'italic',
            },
            {
              type: 'highlight',
              attrs: {
                color: 'var(--tt-color-highlight-brown)',
              },
            },
          ],
          text: "Example: You will receive customer support tickets as plain text. Each ticket may be a single message or a conversation thread. Classify based on the customer's initial issue/question.",
        },
      ],
    },
    {
      type: 'heading',
      attrs: {
        id: '41ab51f0-23e7-47fd-8142-24edf157767f',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Output Format',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '531c2dd6-3103-4c4a-8cdf-9c371bdc6226',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'For each piece of content, provide:',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '4ea0704a-12b5-4216-b784-a5e4aaeb41e2',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  text: 'Category',
                },
                {
                  type: 'text',
                  text: ': ',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                  ],
                  text: '[CATEGORY 1 / CATEGORY 2 / CATEGORY 3 / N/A]',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: 'e70fcb78-553f-4399-93d2-7897bb8586cd',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  text: 'Confidence',
                },
                {
                  type: 'text',
                  text: ': ',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                  ],
                  text: '[High / Medium / Low]',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '33ea4cdc-761b-4546-bd5f-b4101f0da97e',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  text: 'Reasoning',
                },
                {
                  type: 'text',
                  text: ': ',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                  ],
                  text: '[Brief explanation of why you chose this category, citing specific indicators]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '2bd80f7d-0978-416b-beb2-454595136bbc',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          text: 'Including confidence levels and reasoning helps you iterate on the prompt and identify patterns in misclassifications. This is especially useful for training or improving your categorization system over time!',
        },
      ],
    },
    {
      type: 'response-shape',
      attrs: {
        jsonNode: {
          t: 'object',
          name: 'response',
          fields: {
            '0.5963248992269042': {
              t: 'string',
              name: 'reasoning',
              nullable: false,
            },
            '0.6751727044030195': {
              t: 'enum',
              name: 'confidence',
              values: ['N/A', 'high', 'medium', 'low'],
              nullable: false,
            },
            '6d502597-a53e-49b6-9f60-15a626a82380': {
              t: 'enum',
              name: 'category',
              values: ['N/A', 'CATEGORY 1', 'CATEGORY 2', 'CATEGORY 3'],
              nullable: false,
            },
          },
          nullable: false,
        },
      },
    },
    {
      type: 'horizontalRule',
    },
    {
      type: 'heading',
      attrs: {
        id: 'c2d2eb2d-9d06-42a1-ada7-5832e7384f72',
        textAlign: null,
        level: 2,
      },
      content: [
        {
          type: 'text',
          text: 'Examples',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '93f14fdd-9e07-4511-9dbd-6dc041b4515d',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[CATEGORY 1]',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
          ],
          text: ':',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text)',
              },
            },
          ],
          text: ' ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '"',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[EXAMPLE TEXT]',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '"',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: 'b3734994-f602-43d6-8eea-bf843b3c7d0b',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'italic',
                    },
                  ],
                  text: 'Reasoning: ',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'italic',
                    },
                  ],
                  text: '[Why this fits category 1]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'c28faf53-f6f3-4752-ac54-6923bbb1a0b5',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[CATEGORY 2]',
        },
        {
          type: 'text',
          text: ': ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: '"',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[EXAMPLE TEXT]',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: '"',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '090bb2f4-ebac-4c89-a303-89a2c84c5124',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'italic',
                    },
                  ],
                  text: 'Reasoning: ',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'italic',
                    },
                  ],
                  text: '[Why this fits category 2]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '653dc3ca-9e27-40a4-a78d-b85caa448172',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[CATEGORY 3]',
        },
        {
          type: 'text',
          text: ': ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: '"',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[EXAMPLE TEXT]',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: '"',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: 'a67ae8d6-5650-46df-ac17-0ca0926fb998',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'italic',
                    },
                  ],
                  text: 'Reasoning: ',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'italic',
                    },
                  ],
                  text: '[Why this fits category 3]',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: 'ebf852dd-d350-4f76-aafa-8324d336cd45',
        textAlign: null,
      },
      content: [
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: 'N/A',
        },
        {
          type: 'text',
          text: ': ',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: '"',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'textStyle',
              attrs: {
                color: 'var(--tt-color-text-blue)',
              },
            },
            {
              type: 'bold',
            },
          ],
          text: '[EXAMPLE TEXT]',
        },
        {
          type: 'text',
          marks: [
            {
              type: 'bold',
            },
          ],
          text: '"',
        },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              attrs: {
                id: '90c251d8-a4a1-42cb-846c-0836c26dd63a',
                textAlign: null,
              },
              content: [
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'italic',
                    },
                  ],
                  text: 'Reasoning: ',
                },
                {
                  type: 'text',
                  marks: [
                    {
                      type: 'textStyle',
                      attrs: {
                        color: 'var(--tt-color-text-blue)',
                      },
                    },
                    {
                      type: 'italic',
                    },
                  ],
                  text: "[Why this doesn't fit any category]",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'blockquote',
      content: [
        {
          type: 'paragraph',
          attrs: {
            id: 'c39d4610-1893-4b27-a0de-29c7c715a211',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: 'Example section:',
            },
          ],
        },
        {
          type: 'paragraph',
          attrs: {
            id: '30f56ff6-9be5-48ee-9123-02a33bbaebad',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'bold',
                },
              ],
              text: 'Technical Integration Issues',
            },
            {
              type: 'text',
              text: ': ',
            },
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: '"I\'m getting a 403 Forbidden error when calling /v1/shipments endpoint. My API key is valid and worked yesterday."',
            },
          ],
        },
        {
          type: 'bulletList',
          content: [
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'cff57216-e5ac-499f-ba54-246910d8e3e5',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Reasoning: Explicit mention of API endpoint, error code, and authentication - all technical integration indicators',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: 'paragraph',
          attrs: {
            id: '28a1ff35-0ad7-46b4-bbd2-f9854860a604',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'bold',
                },
              ],
              text: 'Billing & Account Management',
            },
            {
              type: 'text',
              text: ': ',
            },
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: '"I need to update my credit card on file before the next billing cycle."',
            },
          ],
        },
        {
          type: 'bulletList',
          content: [
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'de05ed75-f01d-4766-a329-0867a0218d4c',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Reasoning: Directly references payment method and billing - clear account management request',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: 'paragraph',
          attrs: {
            id: '3207a7e5-6905-408e-b1cd-a9864685d51e',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'bold',
                },
              ],
              text: 'Shipping Operations',
            },
            {
              type: 'text',
              text: ': ',
            },
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: '"Customer says the package was delivered to the wrong address. Tracking shows it was left at 123 Oak St but should have gone to 123 Elm St."',
            },
          ],
        },
        {
          type: 'bulletList',
          content: [
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '079a7a34-e12a-482b-a5d9-1237469a238f',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Reasoning: Focuses on a specific shipment delivery issue with tracking details - operational problem',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: 'paragraph',
          attrs: {
            id: '8a42d31b-a627-46d7-bfd7-795c0871605f',
            textAlign: null,
          },
          content: [
            {
              type: 'text',
              marks: [
                {
                  type: 'bold',
                },
              ],
              text: 'N/A',
            },
            {
              type: 'text',
              text: ': ',
            },
            {
              type: 'text',
              marks: [
                {
                  type: 'italic',
                },
              ],
              text: '"Do you have any job openings for customer support roles?"',
            },
          ],
        },
        {
          type: 'bulletList',
          content: [
            {
              type: 'listItem',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '784c4ae9-055c-4851-9eaa-6a6278eb2b7f',
                    textAlign: null,
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'italic',
                        },
                      ],
                      text: 'Reasoning: General HR inquiry unrelated to any product categories',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: {
        id: '59c6c09b-3ab7-478d-aab3-c2398eb5dcf8',
        textAlign: null,
      },
    },
  ],
};

export const TEMPLATES = {
  Google: GOOGLE_SEARCH_TEMPLATE,
  FindMentionsOf: FIND_MENTIONS_OF_TEMPLATE,
  MeetingSummary: MEETING_SUMMARY_TEMPLATE,
  ContentClassifier: CONTENT_CLASSIFIER_TEMPLATE,
};
